module.exports = __webpack_public_path__ + "img/icon_sec3_01.f3e2d154.png";